import React, { useEffect, useState, useRef } from 'react';
import styles from './scaleSkeleton.module.scss';
function ScaleSkeleton(props: any) {

    useEffect(() => {
        return () => {
        }
    }, [])

    return (
        <div className={`${styles.homeTool_content}`}>
            <div className={`${styles.title}`}>
                我的工具
            </div>
            <div className={`${styles.content}`}>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
            </div>
        </div>
    )

}

export default ScaleSkeleton;